import './App.css';

import * as Sentry from '@sentry/react';
import { AppProvider } from '@/providers/app';
import { AppRoutes } from '@/routes';
import { Routes, BrowserRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import { initSentry } from './lib/sentryClient';

import amplifyconfig from './amplifyconfiguration.json';
import { Amplify } from 'aws-amplify';

import Favicon from './components/Elements/Meta/Favicon';

initSentry();

Amplify.configure(amplifyconfig);

const App = () => (
  <Sentry.ErrorBoundary>
    <AppProvider>
      <Favicon />
      <Box marginBottom={'16px'}>
        <AppRoutes />
      </Box>
    </AppProvider>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);

export default App;
